<template>
	<div class="car">
		<div>
			<p class="car__title">{{ car?.brand }} {{ car?.name }}</p>
			<div class="car__description">
				<span
					>{{ $t('modules.cars_module.single_car.or_similar') }}
					{{ i18nService.$tDynamic('pages.panel.discount_codes.code_id.segments', segmentsMapTranslations[car?.segment.name]) }}</span
				>
				<CarsSingleCarSegmentTooltip :segment="car.segment.name" :segmentID="car.segment.id" />
			</div>
			<div v-if="isMobile_xl">
				<GlobalImage v-if="car?.image" class="car__image" :src="car?.image" :alt="car?.fullName" />
				<GlobalImage v-else class="car__image" src="car-placeholder.png" :alt="car?.fullName" />
			</div>
			<div class="car__info-badges">
				<GlobalCarParameter
					v-for="(param, i) in filteredParametersByBags(car.parameters)"
					:key="i"
					:isElectric="isElectricCar"
					:parameter="param" />
			</div>
			<div class="car__price-container">
				<div class="car__price-amount">
					<div class="car__price-old">
						{{ formatPrice(car.segment?.pricePerDay) }}
					</div>
					<div class="car__price">
						{{ formatPrice(priceDiscounted) }} <span>/{{ $t('common.for') }} {{ $t('common.day') }}</span>
					</div>
				</div>
				<ButtonPrimary @click="handleOpen">{{ $t('common.select') }}</ButtonPrimary>
			</div>
		</div>
		<div v-if="!isMobile_xl">
			<GlobalImage v-if="car?.image" class="car__image" :src="car?.image" :alt="car?.fullName" />
			<GlobalImage v-else class="car__image" src="car-placeholder.png" :alt="car?.fullName" />
		</div>
	</div>
	<CarInquiryModal
		v-model="open"
		:car="car"
		:min-val="props.minVal"
		:max-val="props.maxVal"
		:type="props.type"
		:label="props.label"
		:timeframe="props.timeframe"
		:discount-percentage="props.discountPercentage" />
</template>
<script setup lang="ts">
const props = defineProps<{
	car: IProductModel
	minVal: number
	maxVal: number
	type: ESpecialDailyOfferType
	discountPercentage?: number
	label?: EFormLabel
	timeframe: EContactFormRentalTimeframe
}>()
const { isMobile_xl } = useWindowWidth()
const open = ref(false)
function handleOpen() {
	open.value = true
}
const isElectricCar = props.car.parameters.find((p) => p.name === 'Fuel Type')?.value === 'Elektryczny'
const i18nService = usei18nService()

const priceDiscounted = computed(() => {
	if (!props.discountPercentage) {
		return getCarPricePerDay(props.car)
	}
	const discount = props.discountPercentage / 100

	return getCarPricePerDay(props.car) - getCarPricePerDay(props.car) * discount
})
</script>
<style scoped lang="scss">
@import './Car';
</style>
